import * as React from "react";
import type { SVGProps } from "react";
const SvgClockMulticolor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle cx={12} cy={12} r={9} fill="#E61827" />
    <path
      fill="#fff"
      d="M14.3 15.75c.19.2.45.3.71.3h.02c.25 0 .5-.1.7-.29.38-.38.39-1.02 0-1.41L13 11.59V6.48c0-.55-.45-1-1-1s-1 .45-1 1V12c0 .26.1.51.29.7l3.01 3.05Z"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M2 12c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 2 12 2 2 6.49 2 12Zm2 0c0-4.41 3.59-8 8-8s8 3.59 8 8-3.59 8-8 8-8-3.59-8-8Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgClockMulticolor;
